// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

import "@rails/actiontext"
import * as ActiveStorage from "@rails/activestorage"

ActiveStorage.start()

function scrollToTop() {
    if (window.scrollscape) {
        window.scrollscape.scrollTo(0, { immediate: true, force: true })
    } else {
        window.scrollTo(0, 0)
    }
}

function smoothScrollToHashTarget() {
    const hash = window.location.hash
    if (!hash || hash.length <= 1) return

    const target = document.getElementById(decodeURIComponent(hash.slice(1)))
    if (!target) return

    target.scrollIntoView({ behavior: "smooth", block: "start" })
}

document.addEventListener('turbo:before-cache', function() {
    document.getElementById('toast-container')?.replaceChildren()

    // Clean up modal before Turbo caches the page
    const modal = document.querySelector('.image-cropper-modal')
    if (modal) {
        modal.remove()
        // console.log('[Turbo] Image cropper modal removed before cache')
    }

    // Clear global flags
    window.__adminCropperModalBound = false
    window.adminActiveImageCropper = null
})

document.addEventListener('turbo:load', function() {
    // Reset global state on new page load
    window.__adminCropperModalBound = false
    window.adminActiveImageCropper = null
    console.log('[Turbo] Image cropper state reset')
    // Turbo and ScrollScape each retain scroll state. Resetting through
    // ScrollScape keeps their state in sync on every new page visit.
    // A hash link remains an intentional exception and scrolls to its target.
    window.requestAnimationFrame(() => {
        if (window.location.hash.length > 1) {
            smoothScrollToHashTarget()
        } else {
            scrollToTop()
        }

        window.__turboNavigationInProgress = false
    })
})

document.addEventListener('turbo:before-visit', function() {
    // Modal controllers can disconnect while Turbo swaps pages. Let them
    // release their body lock without restoring the outgoing page's position.
    window.__turboNavigationInProgress = true

    // Clean up any active cropper before navigation
    if (window.adminActiveImageCropper) {
        window.adminActiveImageCropper.cancelCrop()
        window.adminActiveImageCropper = null
    }
})

window.addEventListener("hashchange", smoothScrollToHashTarget)
